import React, { useState, useEffect } from 'react'
import { Button } from '@material-ui/core'
import DatePicker from 'common/DatePicker'
import './CustomDatePicker.less'

function CustomDatePicker({onApply, comercialAdvisorList = false, fromReceived = null, toReceived = null}){
    const [openCustom, setOpenCustom] = useState(false)
    const [fromDate, setFromDate] = useState(fromReceived)
    const [toDate, setToDate] = useState(toReceived)
    const [disableApply, setDisableApply] = useState(true)

    function handleOpenCustomDate(){
      openCustom? 
          setOpenCustom(false)
        :
          setOpenCustom(true)
    }

    useEffect(()=>{
      let incompleteSelect = !fromDate || !toDate
      setDisableApply(incompleteSelect)
    },[fromDate, toDate])

    function onChangeDateFrom(dateSelected){
      setFromDate(dateSelected)
    }
    
    function onChangeDateTo(dateSelected){
      setToDate(dateSelected)
    }

    function handleApply(){
      let splitFrom = fromDate.split('/')
      let fromForLabel = `${splitFrom[2]}/${splitFrom[1]}/${splitFrom[0]}`
      
      let splitTo = toDate.split('/')
      let toForLabel = `${splitTo[2]}/${splitTo[1]}/${splitTo[0]}`
      
      let dateSelected = `${fromForLabel} - ${toForLabel}`
      
      let data = {
        value: [fromDate, toDate],
        label: dateSelected
      }

      onApply(data)
    }
    return (
        <div className={`custom-date`}>
            <button className={`custom-date-item  ${openCustom && 'custom-date-item-active'} ${comercialAdvisorList? "date-item" : "admin"}`} onClick={handleOpenCustomDate}>
                  <span className="custom-date-span" >Fecha personalizada</span>
                  <i className="material-icons">{openCustom ? 'expand_less' : 'expand_more'}</i>
            </button>
            {openCustom && 
              <div className='custom-date-pickers'>
                <div className="custom-date-pickers-container">
                  <label className='custom-date-pickers-container-label'>Desde</label>
                  <div className="custom-date-pickers-container-picker-cont">
                    <DatePicker
                      placeholderText=''
                      selected={fromDate}
                      value={fromDate}
                      maxDate={toDate || new Date()}
                      onChange={(date)=>onChangeDateFrom(date)}
                    />
                  </div>
                </div>
                <div className="custom-date-pickers-container">
                  <label className='custom-date-pickers-container-label'>Hasta</label>
                  <div className="custom-date-pickers-container-picker-cont">
                    <DatePicker
                      placeholderText=''
                      value={toDate}
                      maxDate={new Date()}
                      minDate={fromDate}
                      onChange={(date)=>onChangeDateTo(date)}
                    />
                  </div>
                </div>
                <div className="d-flex mt-2">
                  <Button 
                    disableElevation 
                    size="small" 
                    color="primary" 
                    variant="contained" 
                    disabled={disableApply}
                    onClick={handleApply}
                    >
                    Aplicar
                  </Button>
                </div>
              </div>
            }
        </div>
    )
}

export default CustomDatePicker